import { FlexColumn, LabeledData, useMoment } from '@gorila-shared-ui/components';
import { Block } from 'baseui/block';
import { Cell, Grid } from 'baseui/layout-grid';
import { memo } from 'react';
import { useStyles } from '../../../hooks/useStyles';
import { LiveStatusConvoyDetail } from '../../../types/liveStatus';

type Props = {
  liveStatusConvoyDetail: LiveStatusConvoyDetail;
};
function ConvoyDetailCardBody({ liveStatusConvoyDetail }: Readonly<Props>) {
  const { css, theme } = useStyles();
  const { formatDateFromTs } = useMoment();
  const labelWidht = '70px';

  return (
    <Block
      className={css({
        padding: theme.sizing.scale600,
      })}
    >
      <Grid
        gridColumns={12}
        gridGaps={[8]}
        gridGutters={[16]}
        gridMargins={[0]}
      >
        <Cell span={[12, 12, 12, 12, 6]}>
          <FlexColumn gap={0}>
            <LabeledData
              label={'Cliente'}
              content={liveStatusConvoyDetail.client}
              labelWidth={labelWidht}
            />
            <LabeledData
              label={'Subcliente'}
              content={liveStatusConvoyDetail.subClient}
              labelWidth={labelWidht}
            />
            <LabeledData
              label={'Subcuenta'}
              content={liveStatusConvoyDetail.subAccount ?? '-'}
              labelWidth={labelWidht}
            />
            <LabeledData
              label={'Activos'}
              content={liveStatusConvoyDetail.assignedAssets.toString().replace(',', ', ') ?? '-'}
              labelWidth={labelWidht}
              inline={false}
            />
          </FlexColumn>
        </Cell>
        <Cell span={[12, 12, 12, 12, 6]}>
          <FlexColumn gap={0}>
            <LabeledData
              label={'Fecha inicio'}
              content={liveStatusConvoyDetail.startDate ? formatDateFromTs(liveStatusConvoyDetail.startDate) : '-'}
              labelWidth={'150px'}
            />
            <LabeledData
              label={'Fecha fin'}
              content={liveStatusConvoyDetail.endDate ? formatDateFromTs(liveStatusConvoyDetail.endDate) : '-'}
              labelWidth={'150px'}
            />
            <LabeledData
              label={'Distancia de separación'}
              content={`${liveStatusConvoyDetail.separationDistance} mts.`}
              labelWidth={'150px'}
            />
          </FlexColumn>
        </Cell>
      </Grid>
    </Block>
  );
}

export default memo(ConvoyDetailCardBody);
